var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "695751ef887f17613267a959e9ad2468014fcf42"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dfh-corp-sites@designs-for-health"] = {
  id: "695751ef887f17613267a959e9ad2468014fcf42"
};